import React from 'react';
import { TextInput as GenesisTextInput } from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { ControlledFormField } from '@leagueplatform/web-common';

/**
 * A temporary solution which allows us to map the generic
 * regex extension error to something more specific.
 */
const GENERIC_ERROR_MESSAGE = 'Please enter a valid format';
const PHONE_NUMBER_ERROR_MESSAGE = 'Enter a 10 digit phone number';
function getRegExExtensionErrorMessage(linkId: string) {
  switch (linkId) {
    case 'user-phone': {
      return PHONE_NUMBER_ERROR_MESSAGE;
    }
    default: {
      return GENERIC_ERROR_MESSAGE;
    }
  }
}

export interface TextInputProps {
  labelText?: string;
  name: string;
  id: string;
  required?: boolean;
  defaultValue?: string;
  maxLength?: number;
  regex?: string;
}

export const TextInput = ({
  labelText,
  defaultValue,
  id,
  name,
  required,
  regex,
  maxLength,
}: TextInputProps) => {
  const { formatMessage } = useIntl();
  const inputRules = {
    ...(required && {
      required: {
        value: true,
        message: formatMessage({ id: 'THIS_FIELD_IS_REQUIRED' }),
      },
    }),
    ...(maxLength && {
      maxLength: {
        value: maxLength,
        message: `You are over the maximum character limit (${maxLength})`,
      },
    }),
    ...(regex && {
      pattern: {
        value: new RegExp(regex),
        message: getRegExExtensionErrorMessage(name),
      },
    }),
  };

  return (
    <ControlledFormField
      name={name}
      id={name}
      inputOptions={{
        ...inputRules,
        value: defaultValue,
      }}
      label={labelText}
    >
      <GenesisTextInput id={id} aria-required={required} />
    </ControlledFormField>
  );
};
